import { AxiosResponse } from "axios";
import axios, { AutoWrappedResponse } from "../general/HttpClient";

export function ListCalendars(calendarType, skip, limit): Promise<AxiosResponse<AutoWrappedResponse<CalendarViewModel[]>>> {
    return axios.get("/api/calendars/ListCalendars", { params: { calendarType, skip, limit } });
}

export function ResolveCalendars(calendarIDs, startDate, endDate): Promise<AxiosResponse<CalendarViewModel[]>> {
    return axios.post("/api/calendars/ResolveCalendars", { calendarIDs, startDate, endDate });
}

export function GetCalendarsForUser(userID) {
    return axios.get("/api/calendars/GetCalendarsForUser/" + userID);
}

export function GetCalendarAccessPolicies(calendarInstanceID: string): Promise<AxiosResponse<AutoWrappedResponse<CalendarAccessPolicy[]>>> {
    return axios.get(`/api/calendars/GetCalendarAccessPolicies/${calendarInstanceID}`);
}

export function GetMicrosoftCalendarsForUser(email, startDate, endDate) {
    return axios.get("/api/calendars/GetMicrosoftCalendarsForUser/" + email, { params: { startDate, endDate } });
}
export function CreateCalendar(calendar) {
    return axios.post("/api/calendars/CreateCalendar", calendar);
}

export function CreateEvent(event: CreateEventRequest) {
    return axios.post("/api/calendars/CreateEvent", event);
}

export function UpdateEvent(event: UpdateEventRequest, eventId) {
    return axios.post(`/api/calendars/UpdateEvent/${eventId}`, event);
}

export function UpdateCalendarAccessPolicy(request: CalendarAccessPolicyRequest) {
    return axios.post(`/api/calendars/CalendarAccessPolicy`, request);
}

export function UpdateCalendar(calendar) {
    return axios.put("/api/calendars/UpdateCalendar", calendar);
}

export function DeleteCalendar(calendarId) {
    return axios.delete(`/api/calendars/DeleteCalendar/${calendarId}`);
}

export function DeleteEvent(eventId: string) {
    return axios.delete(`/api/calendars/DeleteEvent/${eventId}`);
}

export interface EventMetadata {
    leave: LeaveEventMetadata;
    location: LocationMetadata;
}

export interface LeaveEventMetadata {
    leaveType: string;
}

export interface LocationMetadata {
    name: string;
}

export interface CreateEventRequest {
    calendarID: string;
    title: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    metadata: EventMetadata;
}

export interface UpdateEventRequest {
    title: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    metadata: EventMetadata;
}
export interface CalendarMembershipViewModel {
    id: string;
    userID: string;
}

export interface CalendarViewModel {
    id: string;
    organizationID: string;
    name: string;
    color: string;
    public: boolean;
    syncToMicrosoft: boolean;
    type: string;
    calendarFile: string;
    calendarEvents: CalendarEventViewModel[];
    memberships: CalendarMembershipViewModel[];
}

export interface CalendarEventViewModel {
    id: string;
    title: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    calendarID: string;
    body: string;
    organizerName: string;
    organizerEmail: string;
    sourceID: string;
    metadata: EventMetadata;
}

export interface CalendarMembershipViewModel {
    id: string;
    userID: string;
}

export interface CalendarAccessPolicyRequest {
    calendarInstanceID: string;
    rule: string;
    accessType: number;
}

export interface CalendarAccessPolicy {
    calendarInstanceID: string;
    rule: string;
    accessType: number;
}
